gov-nav-dropdown.active .gov-nav-item__link {
  &::before {
    height: rem-calc(2);
    width: 100%;
  }
}

@include mq($until: md) {
  gov-nav-dropdown.active .gov-nav-item__link {
    border-left: rem-calc(4) white solid;
  }
}

gov-nav gov-nav-dropdown.open .dropdown li.active {
  border-left-width: rem-calc(2);
  border-left-color: white;
}

gov-nav gov-nav-dropdown {
  cursor: pointer;
  //  Relative position we can position child the drop down.
  position: relative;
}

gov-nav gov-nav-dropdown .dropdown {
  display: none;
}

gov-nav gov-nav-dropdown.open .dropdown {
  display: block;
  background-color: var(--gov-nav-bg, var(--gov-color-primary));

  & ul {
    padding-left: 0;
    list-style-type: none;
    margin: 0.2rem 0;

    & li {
      text-align: left;
      margin: 0 0.5rem;
      border-left: 0.175rem solid var(--gov-nav-bg, var(--gov-color-primary));

      & a {
        text-decoration: none;
        color: var(--gov-nav-color, var(--gov-color-neutral-white));
        // We show content as a block so we can set padding.
        display: block;
        padding: 0.75rem 0.5rem;
      }

      &:hover {
        transition: border .25s ease-in-out;
        border-left-color: white;
      }

    }
  }
}

@include mq($until: md) {
  gov-nav gov-nav-dropdown.open .dropdown {
    width: 100%;
  }
}

@include mq($from: md) {
  gov-nav gov-nav-dropdown.open .dropdown {
    position: absolute;
    width: max-content;
    top: 0;
    right: 0;
    z-index: 1;
    transform: translate(0px, 4rem);
  }
}
